export default __webpack_public_path__ + "static/media/tx_mask.98809ed5.svg";